export default "__VITE_ASSET__B2nk_u8Q__"